import type { InfoHintDetail } from '@cou/admin-ui';
import type { AdminEntryDetail } from './entries-client';

export type AdminEntryPick = AdminEntryDetail['picks'][number];

/**
 * The rows behind a Pick's single ⓘ hint, on the Subject column.
 *
 * One hint per row rather than one per column: the ids an operator needs to quote a Pick upstream
 * — athlete, market, outcome, event — all belong to the same Pick, and three separate icons across
 * one row is three places to look for one answer.
 *
 * Only ids. Every other field of the Pick (market type, event name, the call, the result) is
 * already a column on the row, and a hint that repeats the row is noise.
 *
 * The Event id is the *snapshot* id (`contest_events`), the row settlement matched against — not
 * the live catalogue's, which may have churned since (ADR-0004).
 */
export function pickDetails(pick: AdminEntryPick): InfoHintDetail[] {
  return [
    // A team prop carries no Athlete: name the absence rather than offering an empty id to copy.
    pick.athlete.id === null
      ? { label: 'Subject', value: 'Team prop — no athlete' }
      : { label: 'Athlete ID', value: pick.athlete.id, copyable: true },
    { label: 'Market ID', value: pick.marketId, copyable: true },
    { label: 'Outcome ID', value: pick.outcomeId, copyable: true },
    { label: 'Event ID', value: pick.eventId, copyable: true },
  ];
}
